/* eslint-disable sort-keys */
/* eslint-disable react/sort-prop-types */
import React from 'react'
import Select from '@taglivros/oef_componentes/build/components/select'
import { array, bool, func, string } from 'prop-types'
import styled from 'styled-components'
import { ReactComponent as Repeat } from '../../../../assets/icons/repeat.svg'

import moment from 'moment'

const InnerTitle = styled.div`
  color: #343a4f;
  font-size: 16px;
  line-height: 20px;
  margin-left: 35px;
  display: flex;
  align-items: center;
  padding-top: 13px;
  margin-bottom: 20px;

  .card {
    padding: 0px !important;
  }
  svg {
    margin-right: 21px;
  }
  span {
    font-size: 14px;
    color: #343a4f;
    line-height: 18px;
    font-weight: 700;
  }
  .text-selected-month {
    display: flex;
    flex-direction: column;
  }
  .selected-month {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    padding-left: 5px;
  }

  @media (max-width: 410px) {
    align-items: start;
    .selected-month {
      align-items: baseline;
    }
    margin-bottom: 10px;
    margin-left: 25px;
  }
  @media (min-width: 410px) {
    font-size: 13px;
    margin-left: 25px;
    padding-top: 6px;
    align-items: center;

    .text-selected-month {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .selected-month {
      align-items: start;
      align-items: center;
    }
  }
  @media (min-width: 520px) {
    align-items: start;
    margin-left: 35px;

    .text-selected-month {
      display: flex;
      flex-direction: column;
    }
    .selected-month {
      align-items: baseline;
      width: 100%;
    }
    padding-top: 13px;
  }
  @media (min-width: 1056px) {
    align-items: center;
    .text-selected-month {
      display: flex;
      flex-direction: row;
    }
    .selected-month {
      align-items: center;
      width: auto;
    }
    padding-top: 3px;
    margin-bottom: 20px;
  }
`

export const SelectWrapper = styled.div`
         label {
           display: none;
         }
         @media (min-width: 410px) {
           > div {
             padding-bottom: 0px !important;
           }
         }
         select {
           width: 60px;
         }
       `

const validDates = [
  {
    'codigo': '11',
    'value': '11',
    'visualizacao': '11'
  },
  {
    'codigo': '25',
    'value': '25',
    'visualizacao': '25'
  }
]

const ProximaRenovacao = ( { setDays, nextData, selectedDay } ) => {
  function findDefaultDay() {
    const defaultDay = selectedDay
      ? moment( selectedDay, 'YYYY-MM-DD' ).format( 'DD' )
      : '25'
    if ( defaultDay === '25' || defaultDay === '11' ) {
      return validDates.find( item => item.value === defaultDay )
    }
    return validDates.find( item => item.value === '11' )
  }
  return (
    <InnerTitle>
      <Repeat />

      <div className="flex-row text-selected-month">
        <span>Próxima cobrança anual</span>

        <div className="selected-month">
          <SelectWrapper>
            <Select
              defaultOption={ findDefaultDay() }
              itens={ validDates }
              label="Status"
              name="status"
              onChange={ event => setDays( event.value ) }
              required={ true }
            />
          </SelectWrapper>

          <span className="month">
            /{moment( nextData, 'M/YYYY' ).format( 'MM/YYYY' )}
          </span>
        </div>
      </div>
    </InnerTitle>
  )
}

ProximaRenovacao.propTypes = {
  'days': string,
  'disabled': bool,
  'itens': array,
  'nextData': string.isRequired,
  'setDays': func.isRequired,
  'selectedDay': string.isRequired
}

ProximaRenovacao.defaultProps = {
  'disabled': false,
  'itens': [],
  'days': null,
}

export default ProximaRenovacao
